import React, { FC } from 'react';

import { Table, TableItem, Tag } from '@components';
import { Capitalize } from '@utils';
import { Shield, ShieldOff } from 'react-feather';
import { useTranslation } from 'react-i18next';
import AssetCategory from '../../components/tags/AssetCategory';
import Checkmark from '../../components/tags/Checkmark';
import DateFormatted from '../../components/typography/Date';
import ListComponent from '../../utils/ListComponent';

interface HardwareTable {
  filteredAssets: any;
  openAside: any;
  antiVirus?: any;
}

export const HardwareTable: FC<HardwareTable> = ({
  filteredAssets,
  openAside,
  antiVirus,
}) => {
  const tableHeaders: object = [
    'Factuurnummer',
    'Factuurdatum',
    'Gebruiker',
    'Product',
    'Category',
    'Serienummer',
    'Tags',
    'OS',
    'AV',
    'CMC managed',
  ];

  const fixedColumns = [
    { key: 'Factuurnummer', position: 'left' },
    { key: '', position: 'right' },
  ];
  const { t } = useTranslation();

  return (
    <Table header={tableHeaders} fixedColumns={fixedColumns}>
      {filteredAssets?.length > 0 ? (
        <ListComponent
          data={filteredAssets}
          renderItem={(asset, index) => (
            <tr
              key={index}
              onClick={() => openAside(asset)}
              className="cursor-pointer"
            >
              <TableItem type="stickyLeft">
                {asset.ordPro_invoicenr ?? '/'}
              </TableItem>
              <TableItem>
                {asset.ordPro_invoiceDate && (
                  <DateFormatted date={asset.ordPro_invoiceDate} />
                )}
              </TableItem>
              <TableItem>{Capitalize(asset.ordSer_username ?? '/')}</TableItem>
              <TableItem>{asset.ordPro_naam}</TableItem>
              <TableItem>
                <AssetCategory category={asset.ordPro_categorie} />
              </TableItem>
              <TableItem>{asset.ordSer_serial}</TableItem>

              <TableItem>
                {asset.tags?.length > 0 && (
                  <div className="flex gap-1">
                    {asset.tags
                      ?.slice(0, 2)
                      .map((tag: [string], index: number) => (
                        <Tag
                          key={index}
                          style={'muted'}
                          label={tag.tag}
                          lowercase
                        />
                      ))}
                    {asset.tags?.length > 2 && (
                      <Tag
                        key="more"
                        style={'blue'}
                        label={`+${asset.tags?.length - 2}`}
                      />
                    )}
                  </div>
                )}
              </TableItem>
              <TableItem>{asset.matchingOs?.name}</TableItem>
              <TableItem>
                <AvCheck av={antiVirus[asset.device_id]} />
              </TableItem>
              <TableItem>
                <Checkmark
                  check={asset.device_id ? 1 : 0}
                  classname="flex mr-4"
                />
              </TableItem>
            </tr>
          )}
        />
      ) : (
        <tr>
          <td colSpan={tableHeaders.length} className="text-center py-4">
            {t('Geen hardware gevonden.')}
          </td>
        </tr>
      )}
    </Table>
  );
};

export const AvCheck = ({ av }) => {
  if (!av) return <ShieldOff size={18} color="#FF6666" />;
  if (Object.values(av).some((value) => value.includes('Bitdefender'))) {
    return <Shield size={18} color="#76EFD7" />;
  }
  if (Object.values(av).some((value) => value.includes('Defender'))) {
    return <Shield size={18} color="#AFD8F7" />;
  }
};

export default HardwareTable;
